import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e416f72e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "facet-panel facet-panel-year" }
const _hoisted_2 = { class: "facet-panel-header has-background-modest" }
const _hoisted_3 = ["aria-labelledby", "aria-expanded", "hidden"]
const _hoisted_4 = ["data-cy"]
const _hoisted_5 = ["aria-labelledby", "aria-expanded", "hidden"]
const _hoisted_6 = { class: "selected" }
const _hoisted_7 = { class: "has-text-normal level is-mobile all-panel" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "facet-panel-item-year level is-mobile" }
const _hoisted_11 = { class: "level-left is-mobile" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 〜 ")
const _hoisted_13 = { type: "submit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloserController = _resolveComponent("CloserController")!
  const _component_FacetPanelTree = _resolveComponent("FacetPanelTree")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h1", null, [
        _createVNode(_component_CloserController, {
          modelValue: _ctx.state.ariaSelected,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.ariaSelected) = $event)),
          class: "facet-panel-title has-text-widget-title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("label.publicationYear")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    (_ctx.facetItem)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: "facet-panel-tree has-background-contents",
          "aria-labelledby": `tab${_ctx.facet + 1}`,
          "aria-expanded": _ctx.state.ariaSelected,
          hidden: !_ctx.state.ariaSelected
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facetItem?.buckets, (bucket) => {
            return (_openBlock(), _createElementBlock("li", {
              key: bucket,
              class: _normalizeClass({ selected: bucket.isSelected }),
              "data-cy": 'facet-item-' + bucket.keyAsString
            }, [
              _createVNode(_component_FacetPanelTree, {
                name: "publishEra",
                tree: bucket,
                checkedFacet: _ctx.checkedFacet,
                search: _ctx.searchFacet
              }, null, 8, ["tree", "checkedFacet", "search"])
            ], 10, _hoisted_4))
          }), 128))
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "facet-panel-items has-background-contents",
      id: "facet-panel-publish-year",
      role: "tabpanel",
      "aria-labelledby": `tab${_ctx.facet + 1}`,
      "aria-expanded": _ctx.state.ariaSelected,
      hidden: !_ctx.state.ariaSelected
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (!_ctx.route.query.fromYear_facet && !_ctx.route.query.toYear_facet)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("parts.all")), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.fromYear + " ~ " + _ctx.toYear), 1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.toLocale(_ctx.totalHits, _ctx.lang)), 1)
        ])
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.search()), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_AppInput, {
              inputId: "facet-panel-input-from-year",
              modelValue: _ctx.query.fromYear_facet,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.fromYear_facet) = $event)),
              onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.search()), ["enter"])),
              label: _ctx.$t('form.afterPublicationYear'),
              type: "number"
            }, null, 8, ["modelValue", "label"]),
            _hoisted_12,
            _createVNode(_component_AppInput, {
              inputId: "facet-panel-input-to-year",
              modelValue: _ctx.query.toYear_facet,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.query.toYear_facet) = $event)),
              onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.search()), ["enter"])),
              label: _ctx.$t('form.beforePublicationYear'),
              type: "number"
            }, null, 8, ["modelValue", "label"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("label.year")), 1)
          ]),
          _createVNode(_component_AppButton, {
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.clear()), ["prevent"])),
            onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.clear()), ["prevent"]), ["space","enter"])),
            styled: "is-none",
            class: "has-text-link facet-panel-year-clear-button",
            id: "facet-panel-year-clear-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('label.reset')), 1)
            ]),
            _: 1
          }),
          _withDirectives(_createElementVNode("input", _hoisted_13, null, 512), [
            [_vShow, false]
          ])
        ])
      ], 32)
    ], 8, _hoisted_5)
  ]))
}